import { render, staticRenderFns } from "./tickRequest.vue?vue&type=template&id=553223a4&scoped=true"
import script from "./tickRequest.vue?vue&type=script&lang=js"
export * from "./tickRequest.vue?vue&type=script&lang=js"
import style0 from "./tickRequest.vue?vue&type=style&index=0&id=553223a4&prod&lang=css"
import style1 from "./tickRequest.vue?vue&type=style&index=1&id=553223a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553223a4",
  null
  
)

export default component.exports